import { RangerFirearmAssignmentLogResolverBase } from './ranger-firearm-assignment-log.resolver.base';
import { RangerFirearmAssignmentLogService } from './ranger-firearm-assignment-log.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class RangerFirearmAssignmentLogResolver extends RangerFirearmAssignmentLogResolverBase {

  constructor(protected service: RangerFirearmAssignmentLogService) {
    super(service);
  }
}



